
//importaciones de paquetes

import { CustomAutocomplete } from 'common'

//importaciones de componentes
import { Button, Checkbox, Divider, FormControl, FormControlLabel, Grid, TextField } from '@mui/material'
import { ArrowLeftCircle, ArrowRightCircle } from 'react-feather'

export const ModalInsuranceRenewal = ({useFetchInit}) =>{

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,

        defaultData,
        
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    
    // ------------------------------------------------ globalStates
    const { modalOpeningMode} = globalStates

    // ------------------------------------------------ actions
    const { 
        handleClickCloseModal, 
        handleChangeTotalInsurance, 
        handleChangeCheckCuotas,
        onSubmitFormInsuranceRenewal
    } = Actions

    // ------------------------------------------------ Helpers
    
    // ------------------------------------------------ Formularios
    const { FormInsuranceRenewal:{formState, onInputChange, onInputChangeForNumber,onInputChangeForCheckBox} } = Forms
    

    return(
        <>
            <form onSubmit={onSubmitFormInsuranceRenewal}>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2, mt: 5 }}>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth>
                            <label htmlFor="fecha_ren_seguro">Fecha de renovacion de seguro</label>
                            <TextField
                                id='fecha_ren_seguro'
                                name='fecha_ren_seguro'
                                value={ formState.fecha_ren_seguro }
                                onChange={ onInputChange }
                                size='small'
                                hiddenLabel
                                type='date'
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth> 
                            <label htmlFor="seguro">Cuota actual de seguro</label>
                            <TextField
                                id='seguro'
                                name='seguro'
                                value={ formState.seguro }
                                onChange={ onInputChange }
                                size='small'
                                placeholder='seguro'
                                hiddenLabel
                                type='text'
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={4} lg={4}>
                        <FormControl fullWidth> 
                            <label htmlFor="cuotas_restantes">Cuotas restantes del credito</label>
                            <TextField
                                id='cuotas_restantes'
                                name='cuotas_restantes'
                                value={ formState.cuotas_restantes }
                                onChange={ onInputChange }
                                size='small'
                                placeholder='cuotas restantes'
                                hiddenLabel
                                type='text'
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="total_seguro">* Total del nuevo seguro (Q) </label>
                            <TextField
                                id='total_seguro'
                                name='total_seguro'
                                size='small'
                                type='text'
                                placeholder='0'
                                hiddenLabel
                                value={ formState.total_seguro }
                                onChange={ handleChangeTotalInsurance }
                                variant={(modalOpeningMode === 'READONLY') ? 'filled' : 'outlined' }
                                InputProps={{
                                    readOnly: (modalOpeningMode === 'READONLY') ? true : false
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6} lg={6}>
                        <FormControl fullWidth>
                            <label htmlFor="cuota_nuevo_seguro">* Nueva cuota de seguro (Q)</label>
                            <TextField
                                id='cuota_nuevo_seguro'
                                name='cuota_nuevo_seguro'
                                size='small'
                                type='text'
                                placeholder='0'
                                hiddenLabel
                                value={ formState.cuota_nuevo_seguro }
                                onChange={ onInputChange }
                                variant='filled'
                                InputProps={{
                                    readOnly: true
                                }}
                                required
                            />
                        </FormControl>
                    </Grid>
                </Grid>
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 12, lg: 12 }} sx={{ mb: 2 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                                name='check_cuotas'
                                value={formState.check_cuotas}
                                onChange={handleChangeCheckCuotas}
                            />
                          }
                          label="Distribuir pago en cuotas restantes"    
                        />
                    </Grid> 
                </Grid>

                <div className="border-bottom border-secondary "></div>
                <Grid container justifyContent="center" alignItems="center" style={{ height: '10%' }}>                
                    <Grid item xs={12}>
                        <div className="text-center">
                            <Button 
                                startIcon={<ArrowLeftCircle/>}
                                variant="contained"
                                type="button" 
                                className='btn-round'
                                color='warning'
                                onClick={() => handleClickCloseModal(false, 'EDIT')} 
                                sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                            >
                                Volver
                            </Button>

                            {(modalOpeningMode==='EDITABLE') && (
                                <Button
                                    endIcon={<ArrowRightCircle/>}
                                    variant="contained"
                                    type="submit"
                                    className='btn-round'
                                    color='primary'
                                    sx={{ marginRight: 1, marginLeft: 1, marginTop: 3 }}
                                >
                                    Guardar
                                </Button>
                            )}
                        </div>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}
